import { Controller } from "@hotwired/stimulus"

// data-controller="upload-validator"
//   data-upload-validator-max-bytes-value="52428800"
//   data-upload-validator-accepted-extensions-value='["txt","md","pdf"]'
//
//   <input data-upload-validator-target="input" data-action="change->upload-validator#validate">
//   <div data-upload-validator-target="errors" hidden></div>
//   <button data-upload-validator-target="submit"></button>
//
// Pre-flight validation of file size and extension before form submission.
// Mirrors the server-side rules in app/models/source.rb so users get
// immediate feedback instead of round-tripping to the server.
export default class extends Controller {
  static targets = ["input", "errors", "submit"]
  static values = {
    maxBytes: Number,
    acceptedExtensions: Array
  }

  validate() {
    const files = Array.from(this.inputTarget.files || [])
    const errors = []

    files.forEach((file) => {
      if (this.maxBytesValue && file.size > this.maxBytesValue) {
        const got = (file.size / 1024 / 1024).toFixed(1)
        const max = (this.maxBytesValue / 1024 / 1024).toFixed(0)
        errors.push(`${file.name}: too large (${got} MB). Maximum is ${max} MB.`)
      }

      if (this.acceptedExtensionsValue.length > 0) {
        const dot = file.name.lastIndexOf(".")
        const ext = dot >= 0 ? file.name.slice(dot + 1).toLowerCase() : ""
        if (!this.acceptedExtensionsValue.includes(ext)) {
          errors.push(
            `${file.name}: file type ${ext ? "." + ext : "(unknown)"} is not supported. ` +
            `Accepted: ${this.acceptedExtensionsValue.map((e) => "." + e).join(", ")}.`
          )
        }
      }
    })

    this.renderErrors(errors)
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = errors.length > 0
      this.submitTarget.classList.toggle("opacity-50", errors.length > 0)
      this.submitTarget.classList.toggle("cursor-not-allowed", errors.length > 0)
    }
  }

  renderErrors(errors) {
    if (!this.hasErrorsTarget) return
    if (errors.length === 0) {
      this.errorsTarget.hidden = true
      this.errorsTarget.innerHTML = ""
      return
    }
    this.errorsTarget.hidden = false
    const heading = errors.length === 1
      ? "1 file can't be uploaded:"
      : `${errors.length} files can't be uploaded:`
    this.errorsTarget.innerHTML = `
      <p class="font-medium mb-1">${this.#escape(heading)}</p>
      <ul class="list-disc pl-5">
        ${errors.map((e) => `<li>${this.#escape(e)}</li>`).join("")}
      </ul>
    `
  }

  #escape(str) {
    const div = document.createElement("div")
    div.textContent = str
    return div.innerHTML
  }
}
